<div>
  <ul class="timeline">
    <li class="timeline__item" *ngFor="let item of shipment.history">
      <div class="timeline__item__title font-H3">
        <p *ngIf="item.action == ShipmentAction.AssignDriver">
          {{ "Enum.ShipmentStatus." + item.action | translate}} {{item.createdBy?.userType === UserType.DRIVER && (item.createdBy?.firstName &&
          item.createdBy?.lastName) ? "("+ ("Shipments.DriverAccepted" | translate) +")" : "("+ item.createdBy?.firstName +" "+
          item.createdBy?.lastName +")"}}
        </p>

        <p class="status" *ngIf="item.action != ShipmentAction.AssignDriver">
          {{ "Enum.ShipmentStatus." + item.action | translate}}

          <ng-container
            *ngIf="(item.action == ShipmentAction.ArrivePickupLocation || item.action == ShipmentAction.ArriveDropOffLocation)  && item.isAutomatedMobile == true"
          >
            ({{ "Enum.ShipmentStatus.AutomatedMobile" | translate}})
          </ng-container>
          <ng-container *ngIf="item.isAutomatedAVL == true">({{ "Enum.ShipmentStatus.Automated_AVL" | translate}})</ng-container>
        </p>
      </div>
      <span class="timeline__item__content font-H4">{{item?.createdAt | date : 'dd-MM-yyyy hh:mm aa'}}</span>
      <p
        *ngIf="item?.avlDistance &&
        item.action == ShipmentAction.AssignDriver ||
        item.action == ShipmentAction.AcceptDriver ||
        item.action == ShipmentAction.Start ||
        item.action == ShipmentAction.ArrivePickupLocation ||
        item.action == ShipmentAction.GoodsLoaded ||
        item.action == ShipmentAction.ArriveDropOffLocation ||
        item.action == ShipmentAction.GoodsDelivered"
        class="mt-0"
      >
        {{"Shipments.AvlDistance" | translate}}:
        <span class="timeline__item__content">{{(+item?.avlDistance)?.toFixed(2)}} {{"Shipments.km" | translate}}</span>
      </p>

      <p *ngIf="shipment?.loadingOffTime && item.action == ShipmentAction.ArrivePickupLocation">
        {{"Shipments.WaitingTime" | translate}}:
        <span class="timeline__item__content text-warn">{{(shipment?.loadingOffTime)?.toFixed(2)}} {{"Shipments.Hour" | translate}}</span>
      </p>
      <p *ngIf="shipment?.droppingOffTime && item.action == ShipmentAction.ArriveDropOffLocation">
        {{"Shipments.WaitingTime" | translate}}:
        <span class="timeline__item__content text-warn">{{(shipment?.droppingOffTime)?.toFixed(2)}} {{"Shipments.Hour" | translate}}</span>
      </p>
    </li>
  </ul>
</div>
